<template>
<svg
xmlns="http://www.w3.org/2000/svg"
:fill="fill"
viewBox="0 0 24 24"
stroke="currentColor"
:class="classes"
>
<path
    :stroke="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
/>
</svg>

</template>
<script >
export default {
    props: {
        fill: {
            type: String,
            default:()=>'none'
        },
        classes: {
            type: String,
            default:()=>"w-10 p-1"
        },
        stroke: {
            type: String,
            default:()=>"#9D9D9D",
        }
    },
}
</script>
<style scoped>
</style>